export enum PaymentType {
  credit_card = 'credit_card',
  direct_debit = 'direct_debit',
  pay_pal = 'pay_pal'
}
